import { useEffect } from "react";
import Table from "../../../component/table/Table";
import { fetchSensori } from "../../../features/sensori/sensoriThunk";
import { useDispatch, useSelector } from "react-redux";
import { selectSensori, selectError, selectIsLoading } from "../../../features/sensori/sensoriSlice";
import { fetchCompanies } from "../../../features/company/companyThunk";
const SubLogisticaSensori = () => {
  const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
  const columns = [
    { field: "sensore_name", headerName: "Nome del dispositivo", width: 381 },
    { field: "sensore_tipo", headerName: "Tipo", width: 189 },
    { field: "modelllo", headerName: "Modello", width: 189 },
    { field: "matricola", headerName: "Matricola", width: 189 },
    { field: "sensore_gps", headerName: "Posizione GPS", width: 147 },
    { field: "data_installazione", headerName: "Data installazione", width: 174 },
    { field: "ultimo_agginornamento", headerName: "Ultimo aggiornamento", width: 174 },
    { field: "status", headerName: "Stato", width: 174 },
    { field: "azioni", headerName: "Azioni", width: 100, sortable: false }
  ];
  const sensori = useSelector(selectSensori) || [];
  const sensoriLoading = useSelector(selectIsLoading);
  const sensoriError = useSelector(selectError);
  const dispatch = useDispatch();
  // console.log('sensori',sensori)
  useEffect(() => {
    dispatch(fetchSensori());
    // console.log('data of fetch', fetchSensori());
  }, [dispatch, sensori.length, selectSelectedCompany]);

  useEffect(() => {
    dispatch(fetchCompanies())
  },[])

  const formattedSensori = Array.isArray(sensori) ? sensori.map((item) => ({
    id: item?.id || "N/A",
    sensore_name: item?.sensore_name || "N/A",
    sensore_tipo: item?.sensore_tipo || "N/A",
    modelllo: item?.modelllo || "N/A",
    matricola: item?.matricola || "N/A",
    sensore_gps: item?.sensore_gps || "N/A",
    data_installazione: item?.data_installazione || "N/A",
    ultimo_agginornamento: item?.ultimo_agginornamento || "N/A",
    status: item?.status || "N/A",
  })) : []; // Return an empty array if sensori is not an array
  return (
    <div className="pageTemplate">
      {sensoriLoading && <p>Loading...</p>}
      {console.log(sensoriError)}
      {sensoriError && <p style={{ color: "red" }}>Error: {sensoriError.message}</p>}
      {/* Pass formattedSensori instead of static data */}
      <Table
        data={formattedSensori?.length ? formattedSensori : []}
        columns={columns}
        navData={"strucutreSensori"}
        deleteFunctions={"deleteSensore"}
      />
    </div>
  );
};
export default SubLogisticaSensori;